import React from 'react';
import { useParams } from 'react-router-dom';
import '../../css/profile.css';
import OwnProfileRoutes from './own/OwnProfileApp';
import PublicProfilePage from './public/PublicProfilePage';
import { useAuth } from '../../context/AuthContext';

const ProfileEntry = () => {
    const { id } = useParams();
    const { userId } = useAuth();

    const parsedId = Number(id);

    // If logged in AND viewing own profile → private view
    if (userId && parsedId === userId) {
        return <OwnProfileRoutes id={parsedId} />;
        
    }
    // Otherwise → public profile (logged out OR viewing someone else)
    return <PublicProfilePage id={parsedId} />;
};

export default ProfileEntry;